import React, { useRef, useState, useEffect } from "react";
import { useFormikContext } from "formik";

const PinInput = ({ name = "password", label = "PIN" }) => {
    const { setFieldValue, values, errors, touched } = useFormikContext();
    const [pin, setPin] = useState(["", "", "", ""]);
    const [realPin, setRealPin] = useState(["", "", "", ""]);
    const inputs = [useRef(), useRef(), useRef(), useRef()];

    useEffect(() => {
        if (values[name] === "") {
            setPin(["", "", "", ""]);
            setRealPin(["", "", "", ""]);
        }
    }, [values[name], name]);

    const handleChange = (e, index) => {
        const value = e.target.value;
        if (!/^\d?$/.test(value)) return;

        const newRealPin = [...realPin];
        newRealPin[index] = value;

        const newPin = [...pin];
        newPin[index] = value ? "•" : "";

        setRealPin(newRealPin);
        setPin(newPin);
        setFieldValue(name, newRealPin.join(""));

        if (value && index < 3) {
            inputs[index + 1].current.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            const newRealPin = [...realPin];
            const newPin = [...pin];

            if (!realPin[index] && index > 0) {
                newRealPin[index - 1] = "";
                newPin[index - 1] = "";
                setRealPin(newRealPin);
                setPin(newPin);
                inputs[index - 1].current.focus();
            } else {
                newRealPin[index] = "";
                newPin[index] = "";
                setRealPin(newRealPin);
                setPin(newPin);
            }

            setFieldValue(name, newRealPin.join(""));
        }
    };

    return (
        <div className="w-full font-semibold">
            <label className="block mb-1">{label}</label>
            <div className="flex justify-space space-x-2">
                {pin.map((digit, index) => (
                    <input
                        key={index}
                        ref={inputs[index]}
                        type="text"
                        inputMode="numeric"
                        maxLength={1}
                        value={digit}
                        autoComplete="off"
                        onChange={(e) => handleChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        className="w-12 h-12 md:w-10 md:h-10 px-2.5 py-2 text-center text-2xl text-black bg-white border border-gray-300 rounded-md appearance-none focus:outline-none focus:ring-0 focus:border-secondary peer"
                    />
                ))}
            </div>
            {touched[name] && errors[name] && (
                <p className="text-red-500 text-xs italic mt-1">{errors[name]}</p>
            )}
        </div>
    );
};

export default PinInput;